// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { installChunkReloadHandler } from './utils/chunk-reload.js';
// The typeface is served by the product itself (62.55.0 gate E12.5, S1-4): the
// product is first-party and self-hosted (#352), so no page load sends an
// operator's address to a font host. Weights 300-700, every subset (each face
// carries its unicode-range, so a browser downloads only what a page needs).
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './styles/global.css';
import './styles/intake.css';
import './styles/admin.css';
import './styles/toast.css';
import './styles/components.css';
import './styles/design-system.css';
import './styles/high-contrast.css';

// Recover automatically from stale lazy-chunk loads after a deploy (a new build
// changes hashed asset names; an already-open tab still references the old ones).
installChunkReloadHandler();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
